export default __webpack_public_path__ + "53bc79ea3e6728cb7a445678354e35db.svg";